import { Component, OnInit } from "@angular/core";
import { ApplicationPool } from "src/app/services/application.pool";

@Component({
  selector: "app-template",
  templateUrl: "./template.component.html",
  styleUrls: ["./template.component.scss"],
})
export class TemplateComponent implements OnInit {
  constructor(private dataPool: ApplicationPool) {}

  ngOnInit() {}
  get IsLogin() {
    return document.location.href.toLowerCase().indexOf("login/login") >= 0;
  }
  get IsPasswordReset() {
    return document.location.href.toLowerCase().indexOf("login/password") >= 0;
  }
}
